/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowRefreshIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M26.688 11.688C24.75 10.062 22.25 9 19.5 9c-6.125 0-11 4.938-11 11 0 6.125 4.875 11 11 11 2.438 0 4.75-.812 6.563-2.187.687-.5 1.625-.375 2.125.312s.375 1.625-.313 2.125C25.563 33 22.625 34 19.5 34c-7.75 0-14-6.25-14-14 0-7.687 6.25-14 14-14 3.563 0 6.813 1.375 9.313 3.563l1.875-1.876c.437-.437 1-.625 1.562-.625C33.5 7 34.5 8 34.5 9.25v7.25c0 .875-.687 1.5-1.5 1.5h-7.312c-1.25 0-2.188-.937-2.188-2.187 0-.563.188-1.126.625-1.563z"/>}
        </IconWrapper>);
}
